import { FC } from 'react';
import COLORS from 'lib/constants/colors';

interface Props {
  htmlFor?: string;
}

const Label: FC<Props> = ({ children, htmlFor }) => (
  <label htmlFor={htmlFor} style={{ display: 'block', marginBottom: 8 }}>
    <span
      style={{
        fontSize: 12,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        color: COLORS.black,
        letterSpacing: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
      }}
    >
      {children}
    </span>
  </label>
);

export default Label;
